// extracted by mini-css-extract-plugin
export default {"TableContainer":"Table_TableContainer__h+osr","Table":"Table_Table__-hkEn"};